<template>
	<el-dialog
		:title="dialogTitle"
		:visible.sync="visible"
		width="520px"
		center
		append-to-body
		@close="handleClose"
	>
		<p v-if="isBatch" class="batch_tip">已选择 {{ targetIds.length }} 条订单</p>
		<el-radio-group v-model="problemType" class="problem_type_group">
			<el-radio
				v-for="item in problemTypeOptions"
				:key="item.val"
				:label="item.val"
			>{{ item.text }}</el-radio>
		</el-radio-group>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" :loading="loading" @click="handleConfirm">确 认</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'markProblemOrder',
	data() {
		return {
			visible: false,
			loading: false,
			problemType: 0,
			targetIds: [],
			problemTypeOptions: [],
			onSuccess: null,
			isBatch: false,
		}
	},
	computed: {
		dialogTitle() {
			return this.isBatch ? '批量标记问题订单' : '标记为问题订单'
		},
	},
	methods: {
		open(item, problemTypeOptions = [], onSuccess = null) {
			this.isBatch = false
			this.problemTypeOptions = problemTypeOptions.length
				? problemTypeOptions
				: [{ val: 0, text: '正常' }]
			this.targetIds = [item.id]
			this.problemType = this.resolveProblemType(item)
			this.onSuccess = onSuccess
			this.visible = true
		},
		openBatch(ids = [], problemTypeOptions = [], onSuccess = null) {
			const targetIds = Array.isArray(ids)
				? ids.filter((id) => id != null && id !== '')
				: []
			if (!targetIds.length) {
				this.$message({ message: '请先选择订单', type: 'warning' })
				return
			}
			this.isBatch = true
			this.problemTypeOptions = problemTypeOptions.length
				? problemTypeOptions
				: [{ val: 0, text: '正常' }]
			this.targetIds = targetIds
			this.problemType = 0
			this.onSuccess = onSuccess
			this.visible = true
		},
		resolveProblemType(item) {
			if (!item) {
				return 0
			}
			const val = Number(item.is_abnormal) || 0
			if (val === 0) {
				return 0
			}
			if (val === 1) {
				return 10
			}
			const matched = this.problemTypeOptions.find((option) => Number(option.val) === val)
			return matched ? Number(matched.val) : 10
		},
		handleClose() {
			this.visible = false
			this.loading = false
			this.isBatch = false
		},
		handleConfirm() {
			if (!this.targetIds.length) {
				this.$message({ message: '未找到订单数据', type: 'warning' })
				return
			}
			this.loading = true
			this.$store.dispatch('ucenter/opOrderManageMarkProblem', {
				data: {
					ids: this.targetIds.join(','),
					is_abnormal: this.problemType,
				},
				success: (res) => {
					this.loading = false
					if (res.code === 200) {
						this.$message({ type: 'success', message: res.msg || '操作成功' })
						this.visible = false
						if (typeof this.onSuccess === 'function') {
							this.onSuccess(res)
						}
					} else {
						this.$message({ type: 'error', message: res.msg || '操作失败' })
					}
				},
				fail: () => {
					this.loading = false
				},
			})
		},
	},
}
</script>

<style scoped>
.problem_type_group {
	display: flex;
	flex-wrap: wrap;
	gap: 16px 28px;
	padding: 8px 4px 0;
}

.problem_type_group ::v-deep .el-radio {
	margin-right: 0;
	line-height: 24px;
}

.batch_tip {
	margin: 0 4px 12px;
	font-size: 13px;
	color: #666;
}
</style>
